import { z } from 'zod';
import { WidgetType, ZodBaseWidgetConfiguration, TimelineSlot } from '../../types';
import { BaseThirdPartyAd, ZodBaseThirdPartyAdWidgetConfigurationDetails } from '../types';
import { HivestackWidget } from './HivestackWidget';
import { AxiosError } from 'axios';
import { zMarshalToBoolean } from '../../../ReachApi/Marshallers';

export enum HiveStackBaseUrls {
    TESTING = 'https://uat.hivestack.com',
    PRODUCTION = 'https://apps.hivestack.com',
}

export type HivestackAd = BaseThirdPartyAd & {
    popUrl: string;
};

export type HivestackWidgetTimelineSlotParams = {
    ad: HivestackAd;
};

export type HivestackWidgetTimelineSlot = TimelineSlot<
    HivestackWidgetTimelineSlotParams,
    HivestackWidget
>;

/**
 * @example Sample of JSON response Hivestack API returns upon error
 * ```json
 * {
 *   "error_code": "f7csd9876-6fe",
 *   "error": "missing unit audience"
 * }
 * ```
 */
export type HivestackError = AxiosError<{ error: string; error_code: string }>;

export const ZodHivestackWidgetConfigurationDetails =
    ZodBaseThirdPartyAdWidgetConfigurationDetails.extend({
        is_sandbox_campaign: z.unknown().transform(zMarshalToBoolean),
    });

export type HivestackWidgetConfigurationDetails = z.infer<
    typeof ZodHivestackWidgetConfigurationDetails
>;

export const ZodHivestackWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.HIVESTACK),
    config: ZodHivestackWidgetConfigurationDetails,
});

export type HivestackWidgetConfiguration = z.infer<typeof ZodHivestackWidgetConfiguration>;
